import { accountBadgeEntityName, badgeEntityName } from '../../../../backend/features/badges/shared';
import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { useStorageGet, useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
export function useStorageFetchBadgeWithAllRelations(props) {
    var _a;
    const { badgeId } = props;
    const { data: badge, isLoading: isBadgeLoading, error: badgeError } = useStorageGet(badgeEntityName, badgeId);
    const { data: accountBadges, isLoading: isAccountBadgesLoading, error: accountBadgesError, } = useStorageList(accountBadgeEntityName, badge ? { filter: [{ column: 'badgeId', op: '=', value: badge.id }] } : undefined);
    const { data: accounts, isLoading: isAccountsLoading, error: accountsError, } = useStorageList(accountEntityName, (accountBadges === null || accountBadges === void 0 ? void 0 : accountBadges.rows.length)
        ? { filter: [{ id: accountBadges.rows.map((accBadge) => accBadge.columns.accountId), op: 'in' }] }
        : undefined);
    return {
        badge,
        accountBadges: accountBadges !== null && accountBadges !== void 0 ? accountBadges : { rows: [], total: 0 },
        accounts: accounts !== null && accounts !== void 0 ? accounts : { rows: [], total: 0 },
        isLoading: isBadgeLoading || isAccountBadgesLoading || isAccountsLoading,
        error: (_a = badgeError !== null && badgeError !== void 0 ? badgeError : accountBadgesError) !== null && _a !== void 0 ? _a : accountsError,
    };
}
